import { z } from "zod";

import { JobRequestOriginDetails } from "@/data/job-requests/types/JobRequestOriginDetails";

export enum EOriginSystemOwner {
  NOVA = "NOVA",
  VMS = "VMS",
}

export const JobRequestOrigin = z
  .object({
    name: z.string(),
    details: JobRequestOriginDetails,
    systemOwner: z.nativeEnum(EOriginSystemOwner).nullable(),
  })
  .passthrough();

export type JobRequestOrigin = z.infer<typeof JobRequestOrigin>;
